import { PaymentRequestGetUseCase } from '../../../application';

export default class PaymentRequestGetService {

    async execute(event) {
        const data = await PaymentRequestGetUseCase(event);
        return data;
    }
}
